export enum IdpRequestType {
  LOGIN = 'loginURL',
  TOKEN = 'tokenURL',
  REFRESH_TOKEN = 'refreshTokenURL',
  LOGOUT = 'logoutURL'
}
